import React, {useState} from 'react'
import axios from 'axios'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

function AmenidadesItem(props) {
  const amenidad = props.amenidad

  const [inputFile, setInputFile] = useState('')
  const [tituloInput, setTituloInput] = useState('')
  const [descInput, setDescInput] = useState('')

  let idElementoNum = amenidad.idElement.split('-')[2]
  let tituloString = amenidad.title + ''
  let descString = amenidad.description + ''

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('home-amenidad-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-amenidad-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeTitulo = (event) => {
    setTituloInput(event.target.value)
    document.getElementById('ribbon-amenidad-' + idElementoNum).classList.remove('d-none')
  }

  const onChangeDesc = (event) => {
    setDescInput(event.target.value)
    document.getElementById('ribbon-amenidad-' + idElementoNum).classList.remove('d-none')
  }

  const onSubmit = () => {
    // if (!inputFile) {
    //   alert('Seleccione un archivo')
    //   return false
    // }

    const data = new FormData()

    for (let i = 0; i < inputFile.length; i++) {
      data.append('file[]', inputFile[i])
    }

    data.append('name', amenidad.idElement)
    // data.append('titulo', document.getElementById('titulo-concepto-' + idElementoNum).value)
    data.append('title', document.getElementById('titulo-amenidad-' + idElementoNum).value)

    let url = 'https://puntosurgdl.com/backend/'

    console.log(data)
    console.log(url)

    axios
      .post(url + 'uploadNewAmenidad.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          document.getElementById('ribbon-amenidad-' + idElementoNum).classList.add('d-none')
        },
        (error) => {
          alert(error)
        }
      )
  }

  return (
    <div className='col-lg-3 mb-8 conceptoitem' key={amenidad.idElement}>
      <div className='card card-custom overlay overflow-hidden'>
        <div className='card-body p-0 ribbon'>
          <div id={'ribbon-amenidad-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={amenidad.url}
              alt=''
              className={'w-100 rounded img-carousel home-amenidad-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-amenidad-' + idElementoNum}
                name={'file-amenidad-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeImage(event)}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() => document.getElementById('file-amenidad-' + idElementoNum).click()}
              />
            </div>
          </div>
        </div>
      </div>
      <label className='form-label mt-6'>Titulo</label>
      <input
        id={'titulo-amenidad-' + idElementoNum}
        name={'titulo-amenidad-' + idElementoNum}
        className='form-control'
        type='text'
        defaultValue={tituloString}
        onChange={(e) => onChangeTitulo(e)}
      />
      <div className='mt-4 float-end'>
        <button className='btn btn-primary btn-sm' onClick={() => onSubmit()}>
          Guardar
        </button>
      </div>
    </div>
  )
}

export {AmenidadesItem}
